var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('b-notification',{attrs:{"type":_vm.type,"aria-close-label":"Close notification","role":"alert"},on:{"close":function($event){return _vm.$emit('update:message', '')}}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }